// 알림톡 템플릿 — 발송 유형의 단일 진실(백엔드 alimtalk_template). GET /api/alimtalk-templates 응답.

/** 템플릿 모드 — CSV: 변수를 CSV에서 / ACTION: 코드(쿠폰 발급/만료)에서 */
export const ALIMTALK_TEMPLATE_MODE = {
  CSV: 'CSV',
  ACTION: 'ACTION',
} as const;
export type AlimtalkTemplateMode = (typeof ALIMTALK_TEMPLATE_MODE)[keyof typeof ALIMTALK_TEMPLATE_MODE];

/** ACTION 모드 핸들러 이름 (코드 분기 단위) */
export const ALIMTALK_ACTION_TYPE = {
  ISSUE_COUPON_ONLY: 'ISSUE_COUPON_ONLY', // 쿠폰 발급만 (알림톡 X)
  ISSUE_COUPON: 'ISSUE_COUPON', // 쿠폰 발급 + 발급 알림톡
  EXPIRE_COUPON: 'EXPIRE_COUPON', // 만료 알림톡
} as const;
export type AlimtalkActionType = (typeof ALIMTALK_ACTION_TYPE)[keyof typeof ALIMTALK_ACTION_TYPE];

/** BizM 버튼 타입 (AL=앱링크, WL=웹링크, DS=배송조회) */
export const ALIMTALK_BUTTON_TYPE = {
  AL: 'AL',
  WL: 'WL',
  DS: 'DS',
} as const;
export type AlimtalkButtonType = (typeof ALIMTALK_BUTTON_TYPE)[keyof typeof ALIMTALK_BUTTON_TYPE];

/** BizM MsgButton — URL 필드 내 {{변수}} 치환 지원 */
export type AlimtalkButton = {
  name: string;
  type: AlimtalkButtonType;
  scheme_ios?: string;
  scheme_android?: string;
  url_mobile?: string;
  url_pc?: string;
};

/** 비즈엠 메시지 타입 — AT: 알림톡 / AI: 이미지 알림톡 / FT·FI·FW: 친구톡 계열 */
export const ALIMTALK_MESSAGE_TYPE = {
  AT: 'AT',
  AI: 'AI',
  FT: 'FT',
  FI: 'FI',
  FW: 'FW',
} as const;
export type AlimtalkMessageType = (typeof ALIMTALK_MESSAGE_TYPE)[keyof typeof ALIMTALK_MESSAGE_TYPE];

export type AlimtalkTemplate = {
  id: number;
  name: string;
  /** 비즈엠 템플릿 코드 (U77/U75 등). null = 알림톡 메시지 없음(ISSUE_COUPON_ONLY) → 테스트 발송 불가 */
  templateCode: string | null;
  mode: AlimtalkTemplateMode;
  /** CSV 모드는 null */
  actionType: AlimtalkActionType | null;
  messageType: AlimtalkMessageType;
  /** {{변수}} 포함 메시지 본문. 알림톡 없는 유형은 null */
  messageTemplate: string | null;
  variables: string[];
  buttons: AlimtalkButton[];
  isActive: boolean;
  createDate: string;
  updateDate: string;
};

export type AlimtalkTemplateList = AlimtalkTemplate[];

/** GET /api/alimtalk-templates 응답 — 목록은 templates로 래핑 */
export type AlimtalkTemplateListResponse = {
  templates: AlimtalkTemplateList;
};
